<ngx-spinner >
    <img src="../assets/img/loaderrr.gif" alt="" style="width: 250px; height: auto;">
</ngx-spinner>
<p-toast></p-toast>
<router-outlet />